import { render, staticRenderFns } from "./FormasDeCobro.vue?vue&type=template&id=f8147138&"
import script from "./FormasDeCobro.vue?vue&type=script&lang=js&"
export * from "./FormasDeCobro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports